export default __webpack_public_path__ + "static/managementul-ambalajelor-be568690b1c4364da3f46320869b452f.jpg";